import { ProductColor } from '../data/products';

/** Shared UI class bundles for product branding (Flow blue, Pay magenta, Rx teal). */
export function productTheme(color: ProductColor) {
  if (color === 'primary') {
    return {
      iconTile: 'bg-primary-100 dark:bg-primary-500/10 text-primary-600 dark:text-primary-400',
      iconTileHover: 'bg-primary-100 dark:bg-primary-500/10 text-primary-600 dark:text-primary-400 group-hover:bg-primary-200 dark:group-hover:bg-primary-500/20',
      benefitTile: 'bg-primary-100 dark:bg-primary-500/20 text-primary-600 dark:text-primary-400',
      text: 'text-primary-600 dark:text-primary-400',
      textStrong: 'text-primary-600 dark:text-primary-500',
      textHover: 'group-hover:text-primary-600 dark:group-hover:text-primary-400',
      cardHoverWash: 'from-primary-500/0 to-primary-500/0 group-hover:from-primary-500/5 group-hover:to-primary-500/10',
      glow: 'bg-gradient-to-br from-primary-500/10 via-transparent to-primary-500/5',
      ctaWash: 'from-primary-500/5 to-primary-500/10',
      borderHover: 'hover:border-primary-500/50',
      cardHighlight:
        'bg-gradient-to-b from-primary-100 dark:from-primary-500/10 to-white dark:to-dark-900/50 border-2 border-primary-500/50 shadow-xl shadow-primary-500/10',
      ctaGradient:
        'btn-primary',
      tabActive:
        'bg-gradient-to-r from-primary-500 to-primary-600 text-white shadow-lg shadow-primary-500/25',
      arrow:
        'bg-gradient-to-br from-primary-500 to-primary-700 shadow-primary-500/40 hover:shadow-primary-500/55',
      dot: 'bg-primary-500',
      screenshotFrame:
        'border-slate-200 dark:border-dark-700 shadow-slate-900/10 dark:shadow-black/40',
      screenshotChrome:
        'border-slate-200 dark:border-dark-700 bg-slate-50 dark:bg-dark-800/80',
      softBadge: 'bg-primary-100 dark:bg-primary-500/20 text-primary-700 dark:text-primary-300',
      softCard:
        'border-primary-300/70 dark:border-primary-500/40 bg-gradient-to-br from-primary-50 to-white dark:from-primary-500/10 dark:to-dark-900 hover:shadow-primary-500/10',
    };
  }

  if (color === 'rx') {
    return {
      iconTile: 'bg-rx-100 dark:bg-rx-500/10 text-rx-600 dark:text-rx-400',
      iconTileHover: 'bg-rx-100 dark:bg-rx-500/10 text-rx-600 dark:text-rx-400 group-hover:bg-rx-200 dark:group-hover:bg-rx-500/20',
      benefitTile: 'bg-rx-100 dark:bg-rx-500/20 text-rx-600 dark:text-rx-400',
      text: 'text-rx-600 dark:text-rx-400',
      textStrong: 'text-rx-600 dark:text-rx-500',
      textHover: 'group-hover:text-rx-600 dark:group-hover:text-rx-400',
      cardHoverWash: 'from-rx-500/0 to-rx-500/0 group-hover:from-rx-500/5 group-hover:to-rx-500/10',
      glow: 'bg-gradient-to-br from-rx-500/10 via-transparent to-rx-500/5',
      ctaWash: 'from-rx-500/5 to-rx-500/10',
      borderHover: 'hover:border-rx-500/50',
      cardHighlight:
        'bg-gradient-to-b from-rx-100 dark:from-rx-500/10 to-white dark:to-dark-900/50 border-2 border-rx-500/50 shadow-xl shadow-rx-500/10',
      ctaGradient:
        'px-6 py-3 bg-gradient-to-r from-rx-500 to-rx-700 text-white rounded-xl hover:from-rx-400 hover:to-rx-600 transform hover:scale-[1.02] hover:shadow-lg hover:shadow-rx-500/25 transition-all duration-300',
      tabActive:
        'bg-gradient-to-r from-rx-500 to-rx-700 text-white shadow-lg shadow-rx-500/25',
      arrow:
        'bg-gradient-to-br from-rx-500 to-rx-700 shadow-rx-500/40 hover:shadow-rx-500/55',
      dot: 'bg-rx-500',
      screenshotFrame:
        'border-rx-400/40 dark:border-rx-500/50 shadow-rx-500/10 dark:shadow-black/40',
      screenshotChrome:
        'border-rx-200/60 dark:border-rx-500/20 bg-gradient-to-r from-rx-50 to-white dark:from-rx-500/10 dark:to-dark-900',
      softBadge: 'bg-rx-100 dark:bg-rx-500/20 text-rx-700 dark:text-rx-300',
      softCard:
        'border-rx-300/70 dark:border-rx-500/40 bg-gradient-to-br from-rx-50 to-white dark:from-rx-500/10 dark:to-dark-900 hover:shadow-rx-500/10',
    };
  }

  return {
    iconTile: 'bg-accent-100 dark:bg-accent-500/10 text-accent-600 dark:text-accent-400',
    iconTileHover: 'bg-accent-100 dark:bg-accent-500/10 text-accent-600 dark:text-accent-400 group-hover:bg-accent-200 dark:group-hover:bg-accent-500/20',
    benefitTile: 'bg-accent-100 dark:bg-accent-500/20 text-accent-600 dark:text-accent-400',
    text: 'text-accent-600 dark:text-accent-400',
    textStrong: 'text-accent-600 dark:text-accent-500',
    textHover: 'group-hover:text-accent-600 dark:group-hover:text-accent-400',
    cardHoverWash: 'from-accent-500/0 to-accent-500/0 group-hover:from-accent-500/5 group-hover:to-accent-500/10',
    glow: 'bg-gradient-to-br from-accent-500/10 via-transparent to-accent-500/5',
    ctaWash: 'from-accent-500/5 to-accent-500/10',
    borderHover: 'hover:border-accent-500/50',
    cardHighlight:
      'bg-gradient-to-b from-accent-100 dark:from-accent-500/10 to-white dark:to-dark-900/50 border-2 border-accent-500/50 shadow-xl shadow-accent-500/10',
    ctaGradient:
      'px-6 py-3 bg-gradient-to-r from-accent-500 to-accent-600 text-white rounded-xl hover:from-accent-400 hover:to-accent-500 transform hover:scale-[1.02] hover:shadow-lg hover:shadow-accent-500/25 transition-all duration-300',
    tabActive:
      'bg-gradient-to-r from-accent-500 to-accent-600 text-white shadow-lg shadow-accent-500/25',
    arrow:
      'bg-gradient-to-br from-accent-500 to-accent-700 shadow-accent-500/40 hover:shadow-accent-500/55',
    dot: 'bg-accent-500',
    screenshotFrame:
      'border-accent-400/40 dark:border-accent-500/50 shadow-accent-500/10 dark:shadow-black/40',
    screenshotChrome:
      'border-accent-200/60 dark:border-accent-500/20 bg-gradient-to-r from-accent-50 to-white dark:from-accent-500/10 dark:to-dark-900',
    softBadge: 'bg-accent-100 dark:bg-accent-500/20 text-accent-700 dark:text-accent-300',
    softCard:
      'border-accent-300/70 dark:border-accent-500/40 bg-gradient-to-br from-accent-50 to-white dark:from-accent-500/10 dark:to-dark-900 hover:shadow-accent-500/10',
  };
}
